import { authFetch, API_CONFIG } from '../config/api';
import { LearningProgress, StudyStats } from '../types/learning';

export const learningService = {
  // 保存学习进度
  async saveProgress(progress: Omit<LearningProgress, 'userId'> & { studyTimeMinutes?: number }): Promise<boolean> {
    try {
      const response = await authFetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.LEARNING_PROGRESS}`, {
        method: 'POST',
        body: JSON.stringify(progress)
      });
      
      if (!response.ok) {
        return false;
      }
      
      const result = await response.json();
      return result.success;
    } catch (error) {
      console.error('Failed to save progress:', error);
      return false;
    }
  },

  // 获取学习进度
  async getProgress(): Promise<LearningProgress | null> {
    try {
      const response = await authFetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.LEARNING_PROGRESS}`);
      
      if (!response.ok) {
        return null;
      }
      
      const result = await response.json();
      return result.success ? result.data : null;
    } catch (error) {
      console.error('Failed to get progress:', error);
      return null;
    }
  },

  // 获取学习统计
  async getStats(): Promise<StudyStats | null> {
    try {
      const response = await authFetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.LEARNING_STATS}`);
      
      if (!response.ok) {
        return null;
      }
      
      const result = await response.json();
      return result.success ? result.data : null;
    } catch (error) {
      console.error('Failed to get stats:', error);
      return null;
    }
  }
};
